<div *ngIf="!selectionService.selection.selected.length"  class="ddlLabel">No Documents Selected</div>
<mat-form-field>
  <mat-label>Step</mat-label>
  <mat-select [disabled]="!selectionService.selection.selected.length" (selectionChange)="stepChanged($event)" [(value)]="selectedStep">
    <mat-option *ngFor="let step of steps | keyvalue" value="{{step.key}}">{{step.value}}</mat-option>
  </mat-select>
</mat-form-field>
<div class="grey-header heavy">
  <div class="grey-header-left">Translation Options</div>
  <mat-icon class="grey-header-right">translate</mat-icon>
</div>
<mat-form-field style="margin-top: 17.5px;" *ngIf="ucs.inRoles(Role.Developer)">
  <mat-label>Translation Engine</mat-label>
  <mat-select [(value)]="selectedEngine" (selectionChange)="engineChanged($event)">
    <mat-option value="AmazonEngine">Amazon Translate</mat-option>
    <mat-option value="GoogleEngine">Google Translate</mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field>
  <mat-label>From Language</mat-label>
  <mat-select [(value)]="selectedTranslationLanguage">

    <!-- Use link below to find complete list of Amazon language codes. -->
    <!-- https://docs.aws.amazon.com/translate/latest/dg/what-is.html#what-is-languages as of 7/23/2020 -->
    <ng-container *ngIf="selectedEngine === 'AmazonEngine'">
      <mat-option value="af">Afrikaans</mat-option>
      <mat-option value="sq">Albanian</mat-option>
      <mat-option value="am">Amharic</mat-option>
      <mat-option value="ar">Arabic</mat-option>
      <mat-option value="az">Azerbaijani</mat-option>
      <mat-option value="bn">Bengali</mat-option>
      <mat-option value="bs">Bosnian</mat-option>
      <mat-option value="bg">Bulgarian</mat-option>
      <mat-option value="zh">Chinese (Simplified)</mat-option>
      <mat-option value="zh-TW">Chinese (Traditional)</mat-option>
      <mat-option value="hr">Croatian</mat-option>
      <mat-option value="cs">Czech</mat-option>
      <mat-option value="da">Danish</mat-option>
      <mat-option value="fa-AF">Dari</mat-option>
      <mat-option value="nl">Dutch</mat-option>
      <mat-option value="en">English</mat-option>
      <mat-option value="et">Estonian</mat-option>
      <mat-option value="fi">Finnish</mat-option>
      <mat-option value="fr">French</mat-option>
      <mat-option value="fr-CA">French (Canada)</mat-option>
      <mat-option value="ka">Georgian</mat-option>
      <mat-option value="de">German</mat-option>
      <mat-option value="el">Greek</mat-option>
      <mat-option value="ha">Hausa</mat-option>
      <mat-option value="he">Hebrew</mat-option>
      <mat-option value="hi">Hindi</mat-option>
      <mat-option value="hu">Hungarian</mat-option>
      <mat-option value="id">Indonesian</mat-option>
      <mat-option value="it">Italian</mat-option>
      <mat-option value="ja">Japanese</mat-option>
      <mat-option value="ko">Korean</mat-option>
      <mat-option value="lv">Latvian</mat-option>
      <mat-option value="ms">Malay</mat-option>
      <mat-option value="no">Norwegian</mat-option>
      <mat-option value="fa">Persian</mat-option>
      <mat-option value="ps">Pashto</mat-option>
      <mat-option value="pl">Polish</mat-option>
      <mat-option value="pt">Portuguese</mat-option>
      <mat-option value="ro">Romanian</mat-option>
      <mat-option value="ru">Russian</mat-option>
      <mat-option value="sr">Serbian</mat-option>
      <mat-option value="sk">Slovak</mat-option>
      <mat-option value="sl">Slovenian</mat-option>
      <mat-option value="so">Somali</mat-option>
      <mat-option value="es">Spanish</mat-option>
      <mat-option value="es-MX">Spanish (Mexico)</mat-option>
      <mat-option value="sw">Swahili</mat-option>
      <mat-option value="sv">Swedish</mat-option>
      <mat-option value="tl">Tagalog</mat-option>
      <mat-option value="ta">Tamil</mat-option>
      <mat-option value="th">Thai</mat-option>
      <mat-option value="tr">Turkish</mat-option>
      <mat-option value="uk">Ukrainian</mat-option>
      <mat-option value="ur">Urdu</mat-option>
      <mat-option value="vi">Vietnamese</mat-option>
    </ng-container>

    <!-- Use link below to find complete list of Google language codes. -->
    <!-- https://cloud.google.com/translate/docs/languages as of 7/23/2020 -->
    <ng-container *ngIf="selectedEngine === 'GoogleEngine'">
      <mat-option value="">Auto Detect</mat-option>
      <mat-option value="af">Afrikaans</mat-option>
      <mat-option value="sq">Albanian</mat-option>
      <mat-option value="am">Amharic</mat-option>
      <mat-option value="ar">Arabic</mat-option>
      <mat-option value="hy">Armenian</mat-option>
      <mat-option value="az">Azerbaijani</mat-option>
      <mat-option value="eu">Basque</mat-option>
      <mat-option value="be">Belarusian</mat-option>
      <mat-option value="bn">Bengali</mat-option>
      <mat-option value="bs">Bosnian</mat-option>
      <mat-option value="bg">Bulgarian</mat-option>
      <mat-option value="ca">Catalan</mat-option>
      <mat-option value="ceb">Cebuano</mat-option>
      <mat-option value="zh-CN">Chinese (Simplified)</mat-option>
      <mat-option value="zh-TW">Chinese (Traditional)</mat-option>
      <mat-option value="co">Corsican</mat-option>
      <mat-option value="hr">Croatian</mat-option>
      <mat-option value="cs">Czech</mat-option>
      <mat-option value="da">Danish</mat-option>
      <mat-option value="nl">Dutch</mat-option>
      <mat-option value="en">English</mat-option>
      <mat-option value="eo">Esperanto</mat-option>
      <mat-option value="et">Estonian</mat-option>
      <mat-option value="fi">Finnish</mat-option>
      <mat-option value="fr">French</mat-option>
      <mat-option value="fy">Frisian</mat-option>
      <mat-option value="gl">Galician</mat-option>
      <mat-option value="ka">Georgian</mat-option>
      <mat-option value="de">German</mat-option>
      <mat-option value="el">Greek</mat-option>
      <mat-option value="gu">Gujarati</mat-option>
      <mat-option value="ht">Haitian Creole</mat-option>
      <mat-option value="ha">Hausa</mat-option>
      <mat-option value="haw">Hawaiian</mat-option>
      <mat-option value="iw">Hebrew</mat-option>
      <mat-option value="hi">Hindi</mat-option>
      <mat-option value="hmn">Hmong</mat-option>
      <mat-option value="hu">Hungarian</mat-option>
      <mat-option value="is">Icelandic</mat-option>
      <mat-option value="ig">Igbo</mat-option>
      <mat-option value="id">Indonesian</mat-option>
      <mat-option value="ga">Irish</mat-option>
      <mat-option value="it">Italian</mat-option>
      <mat-option value="ja">Japanese</mat-option>
      <mat-option value="jv">Javanese</mat-option>
      <mat-option value="kn">Kannada</mat-option>
      <mat-option value="kk">Kazakh</mat-option>
      <mat-option value="km">Khmer</mat-option>
      <mat-option value="rw">Kinyarwanda</mat-option>
      <mat-option value="ko">Korean</mat-option>
      <mat-option value="ku">Kurdish</mat-option>
      <mat-option value="ky">Kyrgyz</mat-option>
      <mat-option value="lo">Lao</mat-option>
      <mat-option value="la">Latin</mat-option>
      <mat-option value="lv">Latvian</mat-option>
      <mat-option value="lt">Lithuanian</mat-option>
      <mat-option value="lb">Luxembourgish</mat-option>
      <mat-option value="mk">Macedonian</mat-option>
      <mat-option value="mg">Malagasy</mat-option>
      <mat-option value="ms">Malay</mat-option>
      <mat-option value="ml">Malayalam</mat-option>
      <mat-option value="mt">Maltese</mat-option>
      <mat-option value="mi">Maori</mat-option>
      <mat-option value="mr">Marathi</mat-option>
      <mat-option value="mn">Mongolian</mat-option>
      <mat-option value="my">Myanmar (Burmese)</mat-option>
      <mat-option value="ne">Nepali</mat-option>
      <mat-option value="no">Norwegian</mat-option>
      <mat-option value="ny">Nyanja (Chichewa)</mat-option>
      <mat-option value="or">Odia (Oriya)</mat-option>
      <mat-option value="ps">Pashto</mat-option>
      <mat-option value="fa">Persian</mat-option>
      <mat-option value="pl">Polish</mat-option>
      <mat-option value="pt">Portuguese (Portugal, Brazil)</mat-option>
      <mat-option value="pa">Punjabi</mat-option>
      <mat-option value="ro">Romanian</mat-option>
      <mat-option value="ru">Russian</mat-option>
      <mat-option value="sm">Samoan</mat-option>
      <mat-option value="gd">Scots Gaelic</mat-option>
      <mat-option value="sr">Serbian</mat-option>
      <mat-option value="st">Sesotho</mat-option>
      <mat-option value="sn">Shona</mat-option>
      <mat-option value="sd">Sindhi</mat-option>
      <mat-option value="si">Sinhala (Sinhalese)</mat-option>
      <mat-option value="sk">Slovak</mat-option>
      <mat-option value="sl">Slovenian</mat-option>
      <mat-option value="so">Somali</mat-option>
      <mat-option value="es">Spanish</mat-option>
      <mat-option value="su">Sundanese</mat-option>
      <mat-option value="sw">Swahili</mat-option>
      <mat-option value="sv">Swedish</mat-option>
      <mat-option value="tl">Tagalog (Filipino)</mat-option>
      <mat-option value="tg">Tajik</mat-option>
      <mat-option value="ta">Tamil</mat-option>
      <mat-option value="tt">Tatar</mat-option>
      <mat-option value="te">Telugu</mat-option>
      <mat-option value="th">Thai</mat-option>
      <mat-option value="tr">Turkish</mat-option>
      <mat-option value="tk">Turkmen</mat-option>
      <mat-option value="uk">Ukrainian</mat-option>
      <mat-option value="ur">Urdu</mat-option>
      <mat-option value="ug">Uyghur</mat-option>
      <mat-option value="uz">Uzbek</mat-option>
      <mat-option value="vi">Vietnamese</mat-option>
      <mat-option value="cy">Welsh</mat-option>
      <mat-option value="xh">Xhosa</mat-option>
      <mat-option value="yi">Yiddish</mat-option>
      <mat-option value="yo">Yoruba</mat-option>
      <mat-option value="zu">Zulu</mat-option>
    </ng-container>

  </mat-select>
</mat-form-field>
<div class="grey-header heavy">
  <div class="grey-header-left">Transcription Options</div>
  <mat-icon class="grey-header-right">create</mat-icon>
</div>
<mat-form-field style="margin-top: 17.5px;">
  <mat-label>Identify Speakers</mat-label>
  <mat-select [(value)]="speakers">
    <mat-option value="0">Do not identify</mat-option>
    <mat-option value="2">Max Speakers 2</mat-option>
    <mat-option value="3">Max Speakers 3</mat-option>
    <mat-option value="4">Max Speakers 4</mat-option>
    <mat-option value="5">Max Speakers 5</mat-option>
    <mat-option value="6">Max Speakers 6</mat-option>
    <mat-option value="7">Max Speakers 7</mat-option>
    <mat-option value="8">Max Speakers 8</mat-option>
    <mat-option value="9">Max Speakers 9</mat-option>
    <mat-option value="10">Max Speakers 10</mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field>
  <mat-label>From Language</mat-label>
  <mat-select [(value)]="selectedTranscriptionLanguage">
    <mat-option value="en-AU">Australian English</mat-option>
    <mat-option value="pt-BR">Brazilian Portuguese</mat-option>
    <mat-option value="en-GB">British English</mat-option>
    <mat-option value="fr-CA">Canadian French</mat-option>
    <mat-option value="fr-FR">French</mat-option>
    <mat-option value="de-DE">German</mat-option>
    <mat-option value="en-IN">Indian English</mat-option>
    <mat-option value="hi-IN">Indian Hindi</mat-option>
    <mat-option value="it-IT">Italian</mat-option>
    <mat-option value="ko-KR">Korean</mat-option>
    <mat-option value="ar-SA">Modern Standard Arabic</mat-option>
    <mat-option value="es-ES">Spanish</mat-option>
    <mat-option value="en-US">US English</mat-option>
    <mat-option value="es-US">US Spanish</mat-option>
  </mat-select>
</mat-form-field>
<div class="grey-header heavy">
  <div class="grey-header-left">Answer Prompt Options</div>
  <mat-icon class="grey-header-right">batch_prediction</mat-icon>
</div>
<mat-form-field style="margin-top: 17.5px;">
  <mat-label>AI Engine</mat-label>
  <mat-select [(value)]="selectedEngineModel">
    <mat-option *ngFor="let aiEngineModel of aiEngineModels" [value]="aiEngineModel.value">
      <div>{{aiEngineModel.name}}</div>
    </mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field>
  <mat-label>Selected Prompt</mat-label>
  <mat-select [(value)]="selectedPromptId">
    <mat-option *ngFor="let prompt of prompts" [value]="prompt.promptId">
      <div>{{prompt.title}}</div>
    </mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field>
  <mat-label>--- Select Result Field ---</mat-label>
  <mat-select [(value)]="selectedCodingFieldId">
    <mat-optgroup *ngFor="let group of codingFieldGroups" [label]="group.displayTitle">
      <mat-option *ngFor="let field of group.fields" [value]="field.fieldId">
        {{field.displayTitle}}
      </mat-option>
    </mat-optgroup>
  </mat-select>
</mat-form-field>